import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersRoleplayingEvaluationMutateType } from "~/domains";

type RequestDataType = {
  roleplayingConditionId: string;
  id: string;
  body: {
    myEvaluationGoodContent: string;
    myEvaluationImproveContent: string;
    otherUserEvaluationGoodContent: string;
    otherUserEvaluationImproveContent: string;
  };
};

const request = ({ id, roleplayingConditionId, body }: RequestDataType) => {
  return new ApiClient()
    .put<ApiMembersRoleplayingEvaluationMutateType>(
      `/api/members/roleplaying_conditions/${roleplayingConditionId}/roleplaying_evaluations/${id}`,
      {
        roleplayingEvaluation: body,
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersRoleplayingConditionsRoleplayingEvaluationsUpdate =
  ({ options = {} }: PropsType = {}): UseMutationResult<
    ApiMembersRoleplayingEvaluationMutateType,
    RequestDataType
  > => {
    return useMutation(request, { ...options });
  };
